<template>
    <div>
        <div class="c-command-right__carousel">
            <div class="c-mainpage-right__search">
                <el-date-picker v-model="caseDate" type="daterange"
                    class="c-mainpage-right__picker el-date-editor--main-right-style"
                    :range-separator="$t('home.right.to')" :start-placeholder="$t('home.right.startDate')"
                    :end-placeholder="$t('home.right.endDate')" popper-class="mydata" value-format="yyyy-MM-dd"
                    :unlink-panels="true">
                </el-date-picker>
            </div>
            <div class="carousel-box-top">
                <div class="carousel-prev el-icon-arrow-left" :class="{ active: isPrev }" @click="carouselPrevFn"></div>
                <div class="carousel-text">
                    {{ caseListAll.length > 0 ? caseIndex + 1 : 0 }}/{{ caseListAll.length }}
                </div>
                <div class="carousel-next el-icon-arrow-right" :class="{ active: !isPrev }" @click="carouselNextFn">
                </div>
            </div>
            <div class="carousel-box-content">
                <div v-if="caseListAll.length > 0">
                    <el-carousel ref="carousel" :autoplay="false" :indicator-position="'none'" height="150px" :initial-index="caseIndex">
                        <el-carousel-item v-for="item in caseListAll" :key="item.id">
                            <div class="carousel-item">
                                <div class="carousel-item-l">{{ $t('yingji.rightCase.currentEvent') }}</div>
                                <div class="carousel-item-r">
                                    <CustomMarquee :textLength="item.name.length" :autoScroll="true" :speed="0.2">
                                        {{ item.name }}
                                    </CustomMarquee>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-item-l">{{ $t('yingji.rightCase.caseTime') }}</div>
                                <div class="carousel-item-r">
                                    <CustomMarquee :textLength="item.happenTime.length" :autoScroll="true" :speed="0.2">
                                        {{ item.happenTime }}
                                    </CustomMarquee>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-item-l">{{ $t('yingji.rightCase.location') }}</div>
                                <div class="carousel-item-r">
                                    <CustomMarquee :textLength="item.location.length" :autoScroll="true" :speed="0.2">
                                        {{ item.location }}
                                    </CustomMarquee>
                                </div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div v-else class="carousel-no-data">
                    <i class="el-icon-document"></i>
                    <p>{{ $t('common.noData') }}</p>
                </div>
            </div>
        </div>
        <div class="c-command-right__tabs">
            <div class="tabs-l" :class="{ active: tabsType === 'timer' }" @click="tabsType = 'timer'">
                {{ $t('yingji.rightCase.timeline') }}
            </div>
        </div>
        <YScroll style="height:450px" v-if="tabsType === 'timer'">
            <div class="c-command-right__timer">
                <template v-if="caseTaskList.length > 0">
                    <el-timeline>
                        <el-timeline-item v-for="(activity, index) in caseTaskList" :key="index" :icon="activity.icon"
                            :type="activity.type" :color="activity.color" :size="activity.size"
                            :timestamp="activity.createTime" :class="{ active: index === 0 }">
                            {{ activity.action }}
                            <span class="comment" v-if="activity.comment">( {{ activity.comment }} )</span>
                        </el-timeline-item>
                    </el-timeline>
                </template>
                <div v-else class="no-data-placeholder">
                    <i class="el-icon-document"></i>
                    <p>{{ $t('yingji.emergencyCase.noData') }}</p>
                </div>
            </div>
        </YScroll>
    </div>
</template>

<script>
import moment from 'moment';
import { YScroll } from '@CommonComponent';
import api from '../../api/index.js';
import CustomMarquee from '@/page/mainPage/components/CustomMarquee/CustomMarquee.vue';

export default {
    props: {
        rightShow: {
            type: Boolean,
            default: true,
        },
        selectCaseId: {
            type: Function,
        },
        caseListAll: {
            type: Array,
            default: () => [],
        },
        startDate: {
            type: String,
            default: null,
        },
        endDate: {
            type: String,
            default: null,
        },
    },
    emits: [
        'selectCaseId',
        'update:startDate',
        'update:endDate',
    ],
    components: {
        YScroll,
        CustomMarquee,
    },
    data () {
        return {
            tabsType: 'timer',
            isPrev: false,
            caseIndex: 0,
            caseTaskList: [],
            timeflag: null,
        };
    },
    watch: {
        caseListAll: {
            handler (newVal) {
                if (newVal.length > 0) {
                    if (newVal.length - 1 < this.caseIndex) {
                        this.caseIndex = 0;
                    }
                    this.getCaseInfo(newVal[this.caseIndex]);
                    this.refreshCarouselFn();
                }
            },
            immediate: true,
            deep: true,
        },
        caseIndex: {
            handler (index) {
                this.getCaseInfo(this.caseListAll[index]);
            },
        },
    },
    computed: {
        caseDate: {
            get () {
                if (this.startDate && this.endDate) {
                    const start = this.startDate.split(' ')[0];
                    const end = this.endDate.split(' ')[0];
                    return [start, end];
                }
                return [];
            },
            set (newVal) {
                if (newVal && newVal.length === 2) {
                    const [start, end] = newVal;
                    this.$emit('update:startDate', start ? `${start} 00:00:00` : null);
                    this.$emit('update:endDate', end ? `${end} 23:59:59` : null);
                } else {
                    this.$emit('update:startDate', null);
                    this.$emit('update:endDate', null);
                }
            },
        },
    },
    methods: {
        refreshCarouselFn () {
            this.$nextTick(() => {
                this.$refs.carousel && this.$refs.carousel.setActiveItem(this.caseIndex);
            });
        },
        async getCaseInfo (caseItem) {
            const logItem = {
                type: 'primary',
                color: '#49f0fd',
                size: 'normal',
            };
            if (this.caseListAll.length < 1 || !caseItem?.id) {
                clearInterval(this.timeflag);
                this.timeflag = null;
                this.caseTaskList = [];
                return;
            }
            clearInterval(this.timeflag);

            const fetchCaseLog = async () => {
                let list = [];
                const res = await api.getCaseLogList({ id: caseItem.id });
                list = res.data || [];
                const arr = list.map((item) => ({
                    ...logItem,
                    ...item,
                }));
                this.caseTaskList = arr.sort((a, b) => a.createTime - b.createTime);
            };

            await fetchCaseLog();
            this.timeflag = setInterval(fetchCaseLog, 40000);
        },
        carouselPrevFn () {
            this.isPrev = true;
            if (this.caseIndex <= 0) {
                this.caseIndex = this.caseListAll.length - 1;
            } else {
                this.caseIndex--;
            }
            this.$refs.carousel.setActiveItem(this.caseIndex);
            this.$emit('selectCaseId', this.caseListAll[this.caseIndex].id);
        },
        carouselNextFn () {
            this.isPrev = false;
            if (this.caseIndex >= this.caseListAll.length - 1) {
                this.caseIndex = 0;
            } else {
                this.caseIndex++;
            }
            this.$refs.carousel.setActiveItem(this.caseIndex);
            this.$emit('selectCaseId', this.caseListAll[this.caseIndex].id);
        },
    },
    destroyed () {
        clearInterval(this.timeflag);
        this.timeflag = null;
    },
};
</script>

<style lang="scss">
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

.c-command-right-dropdown.el-dropdown-menu {
    background: #071150;
    box-shadow: inset 0px 1px 8px 0px #1343c3;
    border: 1px solid #1343c3;
    border-radius: 3px 3px 3px 3px;
    color: #fff;

    @include themify($zhongke) {
        background: #0a241c;
        box-shadow: inset 0px 1px 8px 0px #1e9a74;
        border: 1px solid #008059;
    }

    .el-dropdown-menu__item {
        text-align: center;
        color: #fff;
        width: 288px;
        line-height: 40px;

        &:hover {
            background: #1343c3;

            @include themify($zhongke) {
                background: #1e9a74;
            }
        }
    }

    .popper__arrow::after {
        border-bottom-color: #1343c3;

        @include themify($zhongke) {
            border-bottom-color: #008059;
        }
    }
}
</style>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

::-webkit-scrollbar {
    width: 5px;
    background-color: transparent;
}

::-webkit-scrollbar-thumb {
    background-color: rgba(144, 147, 153, 0.3);
}

@include b(command-right, c) {
    @include e(carousel) {
        ::v-deep .el-carousel__indicators--horizontal {
            display: none;
        }

        ::v-deep .el-carousel__arrow {
            width: 0;
            height: 0;
            font-size: 0;
        }

        .carousel-box-top {
            display: flex;
            justify-content: space-between;
            margin: 0 auto ;
            width: 172px;
            height: 24px;

            .carousel-prev,
            .carousel-next {
                width: 24px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                color: #ccc;
                background: rgba(204, 204, 204, 0.13);
                border-radius: 1px 1px 1px 1px;
                opacity: 0.5;
                border: 1px solid #ccc;
                cursor: pointer;

                &.active {
                    color: #0affc4;
                    border: 1px solid #0affc4;
                    background: rgba(73, 240, 253, 0.13);
                }
            }

            .carousel-text {
                width: 28px;
                height: 21px;
                font-size: 16px;
                font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                font-weight: bold;
                color: #0affc4;
                line-height: 19px;
            }
        }

        .carousel-box-content {
            margin: 0 10px;

            .carousel-item {
                display: flex;
                line-height: 30px;
                color: #fff;
                font-size: 14px;
                margin-top: 15px;

                .carousel-item-l {
                    width: 90px;
                    text-align: center;
                    background: linear-gradient(90deg,
                            rgba(255, 230, 0, 0) 0%,
                            rgba(255, 230, 0, 0.31) 29%,
                            rgba(255, 230, 0, 0.31) 67%,
                            rgba(255, 230, 0, 0) 100%);
                }

                .carousel-item-r {
                    width: 210px;
                    overflow: hidden;
                }
            }

            .carousel-no-data {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 150px;
                color: rgba(255, 255, 255, 0.5);

                i {
                    font-size: 36px;
                    margin-bottom: 8px;
                    opacity: 0.5;
                }

                p {
                    font-size: 14px;
                    margin: 0;
                }
            }
        }
    }

    @include e(tabs) {
        margin: 0 auto;
        display: flex;
        text-align: center;
        line-height: 34px;
        width: 225px;

        .tabs-l,
        .tabs-r {
            color: rgba(255, 255, 255, 0.9);
            // width: 111px;
            width: 100%;
            border-radius: 1px 0px 0px 1px;
            border: 1px solid;
            cursor: pointer;
            background: linear-gradient(180deg, rgba(6, 10, 36, 0.33) 0%, rgb(43 72 255 / 31%) 100%);
            border-image: linear-gradient(180deg, rgba(6, 10, 36, 0.33), rgba(19, 67, 195, 0.3)) 1 1;

            @include themify($zhongke) {
                background: linear-gradient(180deg, rgba(1, 80, 67, 0.33) 0%, rgba(1, 80, 67, 0.31) 100%);
                border-image: linear-gradient(180deg, rgba(27, 255, 186, 0.39), rgba(27, 255, 186, 0.3)) 1 1;
            }

            &.active {
                color: #fff;
                border-radius: 0px 1px 1px 0px;
                background: linear-gradient(180deg, #052878 0%, #0737ff 100%);
                box-shadow: inset 0px -3px 4px 0px rgb(0 78 255 / 20%);
                -o-border-image: linear-gradient(180deg, rgba(28, 49, 97, 0.47), rgb(28, 49, 97)) 1 1;
                border-image: linear-gradient(180deg, rgba(28, 49, 97, 0.47), rgb(0 78 255)) 1 1;

                @include themify($zhongke) {
                    background: linear-gradient(180deg, #015043 0%, #059374 100%);
                    box-shadow: inset in 0px -3px 4px 0px rgba(153, 255, 255, 0.2);
                    border-image: linear-gradient(180deg, rgba(27, 255, 186, 0.47), rgba(27, 255, 186, 1)) 1 1;
                }
            }
        }
    }

    @include e(navInfo) {
        height: calc(100% - 333px);
        padding: 16px;

        .navInfo-titlle {
            width: 288px;
            margin-bottom: 24px;
            line-height: 40px;
            background: linear-gradient(90deg,
                    rgba(19, 67, 195, 0) 0%,
                    rgba(19, 67, 195, 0.7) 25%,
                    rgba(19, 67, 195, 0.7) 75%,
                    rgba(19, 67, 195, 0) 100%);

            @include themify($zhongke) {
                background: linear-gradient(90deg,
                        rgba(30, 154, 116, 0) 0%,
                        rgba(30, 154, 116, 0.7) 25%,
                        rgba(30, 154, 116, 0.7) 75%,
                        rgba(30, 154, 116, 0) 100%);
            }

            text-align: center;
            color: #fff;
            cursor: pointer;
        }

        .navInfo-content {
            height: calc(100% - 50px);

            ::v-deep .c-aircraft-info__indicators {
                display: flex;
                flex-wrap: wrap;
                align-content: center;
                margin: 0;
            }

            ::v-deep .c-aircraft-info__info-item {
                width: 141px;
            }
        }
    }

    @include e(timer) {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        margin:0;
        padding: 25px 16px 0 30px;

        .comment {
            font-size: 12px;
        }

        ::v-deep .el-timeline-item__node--normal {
            background-color: #49f0fd;

            &::before {
                position: absolute;
                left: -2px;
                top: -2px;
                display: block;
                content: '';
                width: 12px;
                height: 12px;
                border: 2px solid rgba(73, 240, 253, 0.5);
                border-radius: 50%;
            }
        }

        .active {
            ::v-deep .el-timeline-item__node--normal {
                background-color: #ffe600;

                &::before {
                    position: absolute;
                    left: -2px;
                    top: -2px;
                    display: block;
                    content: '';
                    width: 12px;
                    height: 12px;
                    border: 2px solid rgba(255, 230, 0, 0.5);
                    border-radius: 50%;
                }
            }

            ::v-deep .el-timeline-item__timestamp {
                padding: 8px 16px;
                display: inline-block;
                text-align: center;
                border-radius: 4px 4px 4px 4px;
                color: rgba(255, 255, 255, 0.8);
                background: rgba(255, 230, 0, 0.5);
                border-radius: 4px 4px 4px 4px;
                border: 1px solid rgba(255, 230, 0, 0.7);
            }
        }

        ::v-deep .el-timeline-item__tail {
            border-color: #008059;
        }

        ::v-deep .el-timeline-item__content {
            color: #fff;
            font-size: 14px;
            line-height: 20px;
        }

        ::v-deep .el-timeline-item__timestamp {
            padding: 8px 16px;
            display: inline-block;
            text-align: center;
            background: rgba(73, 240, 253, 0.2);
            border-radius: 4px 4px 4px 4px;
            border: 1px solid rgba(73, 240, 253, 0.2);
            color: rgba(255, 255, 255, 0.8);
        }

        .no-data-placeholder {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 200px;
            color: rgba(255, 255, 255, 0.5);

            i {
                font-size: 48px;
                margin-bottom: 10px;
                opacity: 0.5;
            }

            p {
                font-size: 14px;
                margin: 0;
            }
        }
    }

    @include e(flying) {
        font-size: 14px;
        padding: 0 15px;
        color: #fff;
        word-wrap: break-word;

        .flyingSite {
            margin-bottom: 10px;
        }

        span {
            color: #49f0fd;
            line-height: 20px;
        }
    }
}
</style>
